export const COMPANIES_LIST = "COMPANIES_LIST"
export const COMPANIES_LIST_SUCCESS = "COMPANIES_LIST_SUCCESS"
export const COMPANIES_LIST_ERROR = "COMPANIES_LIST_ERROR"

export const COMPANIES_NEW = "COMPANIES_NEW"
export const COMPANIES_NEW_SUCCESS = "COMPANIES_NEW_SUCCESS"
export const COMPANIES_NEW_ERROR = "COMPANIES_NEW_ERROR"

export const COMPANIES_EDIT = "COMPANIES_EDIT"

export const COMPANIES_DELETE = "COMPANIES_DELETE"
export const COMPANIES_DELETE_SUCCESS = "COMPANIES_DELETE_SUCCESS"
export const COMPANIES_DELETE_ERROR = "COMPANIES_DELETE_ERROR"

export const COMPANIES_EXPORT = "COMPANIES_EXPORT"

export const COMPANIES_IMPORT = "COMPANIES_IMPORT"
export const COMPANIES_IMPORT_SUCCESS = "COMPANIES_IMPORT_SUCCESS"
export const COMPANIES_IMPORT_ERROR = "COMPANIES_IMPORT_ERROR"

export const COMPANIES_EXPORT_ACCOUNTS = "COMPANIES_EXPORT_ACCOUNTS"

export const COMPANIES_IMPORT_ACCOUNTS = "COMPANIES_IMPORT_ACCOUNTS"
export const COMPANIES_IMPORT_ACCOUNTS_SUCCESS = "COMPANIES_IMPORT_ACCOUNTS_SUCCESS"
export const COMPANIES_IMPORT_ACCOUNTS_ERROR = "COMPANIES_IMPORT_ACCOUNTS_ERROR"
